import React from 'react';
import { Phone, Zap } from 'lucide-react';

interface MobileBottomBarProps {
  onOpenConsultation?: () => void;
  onNavigateCalculator?: () => void;
}

export const MobileBottomBar: React.FC<MobileBottomBarProps> = ({
  onNavigateCalculator,
  onOpenConsultation,
}) => {
  const handleClickCalculator = () => {
    if (onNavigateCalculator) {
      onNavigateCalculator();
    } else if (onOpenConsultation) {
      onOpenConsultation();
    }
  };

  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-slate-950/95 backdrop-blur-xl border-t border-slate-800 p-3 shadow-2xl">
      <div className="grid grid-cols-2 gap-3 max-w-md mx-auto">
        {/* Left: Direct Call */}
        <a
          href="tel:01027671449"
          className="flex items-center justify-center gap-2 py-3 rounded-xl bg-slate-900 border border-slate-700 text-sky-400 font-extrabold text-xs shadow-sm active:scale-95 transition-transform"
        >
          <Phone className="w-4 h-4 text-sky-400" />
          <span>전화 상담</span>
        </a>

        {/* Right: Real-time Revenue Calculator */}
        <button
          onClick={handleClickCalculator}
          className="flex items-center justify-center gap-1.5 py-3 rounded-xl bg-sky-500 text-white font-black text-xs shadow-md shadow-sky-500/25 active:scale-95 transition-transform cursor-pointer"
        >
          <Zap className="w-4 h-4 text-white" />
          <span>수익 계산기</span>
        </button>
      </div>
    </div>
  );
};

